import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#CC6B49",
    },
    secondary: {
      main: "#D2A24C",
    },
    background: { default: "#FFFFFF" },
  },
});
